export const RESET = 'RESET';
export const SET_ZONE = 'SET_ZONE';
export const START_REGISTER = 'START_REGISTER';
export const ALREADY_REGISTERED = 'ALREADY_REGISTERED';
export const STEP_1 = 'STEP_1';
export const STEP_2 = 'STEP_2';
export const RECOVER_PASSWORD_SENT = 'RECOVER_PASSWORD_SENT';
export const SET_ACTIVITY = 'SET_ACTIVITY';
